// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----page-header-module---container---NOF0q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page-header.module.css
// module id = 328
// module chunks = 263791100135453